/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** @format int32 */
export enum LinkboardDomainEnumsScheduleType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

export interface FeedPigeonEmailSettingsAPIModelsAgencySettingsModel {
  /** @format int32 */
  refNumber?: number;
  agencyName?: string | null;
  agencyEmail?: string | null;
  sendToAgency?: boolean;
  sendOnlyToMe?: boolean;
  sendToNominatedAgency?: boolean;
  nominatedAgencyEmail?: string | null;
  sendToAllAgencyAgents?: boolean;
  sendToAgents?: string[] | null;
  agentDetails?: FeedPigeonEmailSettingsAPIServicesAgentDetails[] | null;
}

export interface FeedPigeonEmailSettingsAPIModelsEmailSettingsModel {
  scheduleType?: LinkboardDomainEnumsScheduleType;
  onlyMatchingFilterEmails?: boolean;
  receiveEmails?: boolean;
  receiveMediaEmails?: boolean;
  /**
   * @minLength 5
   * @maxLength 5
   */
  emailLanguage: string;
}

export interface FeedPigeonEmailSettingsAPIModelsMediaSettingsModel {
  agencies?: FeedPigeonEmailSettingsAPIModelsAgencySettingsModel[] | null;
}

export interface FeedPigeonEmailSettingsAPIModelsPushNotificationSettingsModel {
  receivePushNotifications?: boolean;
  onlyMatchingFilterNotifications?: boolean;
  receiveSelfTapesPushNotifications?: boolean;
}

export interface FeedPigeonEmailSettingsAPIServicesAgentDetails {
  /** @format uuid */
  portalId?: string;
  /** @format int32 */
  siteUserId?: number;
  name?: string | null;
  emailAddress?: string | null;
  /** @format int32 */
  agencyId?: number;
  sendEmail?: boolean;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Email Settings API V1
 * @version v1
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  emailSettings = {
    /**
     * No description
     *
     * @tags EmailSettings
     * @name EmailSettingsDetail
     * @request GET:/EmailSettings/{id}
     * @secure
     */
    emailSettingsDetail: <
      TResponse = FeedPigeonEmailSettingsAPIModelsEmailSettingsModel,
      TError = any,
    >(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/EmailSettings/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailSettings
     * @name EmailSettingsUpdate
     * @request PUT:/EmailSettings/{id}
     * @secure
     */
    emailSettingsUpdate: <
      TResponse = FeedPigeonEmailSettingsAPIModelsEmailSettingsModel,
      TError = any,
    >(
      id: string,
      data: FeedPigeonEmailSettingsAPIModelsEmailSettingsModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/EmailSettings/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  internal = {
    /**
     * No description
     *
     * @tags InternalSettings
     * @name InternalUpdate
     * @request PUT:/internal/{id}
     * @secure
     */
    internalUpdate: <
      TResponse = FeedPigeonEmailSettingsAPIModelsEmailSettingsModel,
      TError = any,
    >(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/internal/${id}`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  pushnotificationsettings = {
    /**
     * No description
     *
     * @tags PushNotificationSettings
     * @name PushnotificationsettingsList
     * @request GET:/pushnotificationsettings
     * @secure
     */
    pushnotificationsettingsList: <
      TResponse = FeedPigeonEmailSettingsAPIModelsPushNotificationSettingsModel,
      TError = any,
    >(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/pushnotificationsettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PushNotificationSettings
     * @name PushnotificationsettingsUpdate
     * @request PUT:/pushnotificationsettings
     * @secure
     */
    pushnotificationsettingsUpdate: <
      TResponse = FeedPigeonEmailSettingsAPIModelsPushNotificationSettingsModel,
      TError = any,
    >(
      data: FeedPigeonEmailSettingsAPIModelsPushNotificationSettingsModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/pushnotificationsettings`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  settings = {
    /**
     * No description
     *
     * @tags Settings
     * @name SettingsDetail
     * @request GET:/Settings/{id}
     * @secure
     */
    settingsDetail: <
      TResponse = FeedPigeonEmailSettingsAPIModelsAgencySettingsModel,
      TError = any,
    >(
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Settings/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name SummaryList
     * @request GET:/Settings/summary
     * @secure
     */
    summaryList: <
      TResponse = FeedPigeonEmailSettingsAPIModelsMediaSettingsModel,
      TError = any,
    >(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Settings/summary`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name SettingsUpdate
     * @request PUT:/Settings
     * @secure
     */
    settingsUpdate: <TResponse = unknown, TError = any>(
      data: FeedPigeonEmailSettingsAPIModelsAgencySettingsModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Settings`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
}
